import { useSelector } from 'react-redux'

import { getLoadedBotHostingId } from '../selectors'

export function useLoadedBotHostingId() {
  return useSelector(getLoadedBotHostingId)
}
